
import { API_ENDPOINTS } from './api-endpoints';
import { crudFactory } from './curd-factory';
import { HttpClientFront } from './http-client-front';


export const getIpoList = {
  
  ...crudFactory(API_ENDPOINTS.IPOS),
  get:({ 
    id,
    ...params 
  }) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.IPOS}/`+id, {
      ...params,
      
    });
  },
  all:(params ) => {    
    return HttpClientFront.get(`${API_ENDPOINTS.IPOS}`, params);
  },
};